import { ModernMiddleBodyLayout2Wrapper } from './ModernMiddleBodyLayout2.styles';
import Heading from '../../../../CommonComponents/Heading/Heading';
import Button from '../../../../CommonComponents/Button/Button';
import Description from '../../../../CommonComponents/Description/Description';
import RenderMap from '../../RenderMap';
export const ModernMiddleBodyLayout2 = (props) => {
  const { middleBodyMapState, propStyle, mapLatLong } = props;
  return (
    <ModernMiddleBodyLayout2Wrapper
      className={`map${middleBodyMapState?.mapData?.mapType}_container`}
      themeStyle={propStyle}
    >
      <div className="left_section">
        <div className="left_section_top">
          {middleBodyMapState?.heading?.text && (
            <Heading headingData={middleBodyMapState?.heading} />
          )}
          {middleBodyMapState?.description?.text && (
            <Description descriptionData={middleBodyMapState?.description} />
          )}
        </div>
        <div className="left_section_bottom">
          {middleBodyMapState?.button?.content?.map((btnData, idx) => (
            <Button
              key={btnData?.id || idx}
              type={middleBodyMapState?.button?.type}
              btnData={{
                ...btnData,
                actions: {
                  ...btnData?.actions,
                  handler: middleBodyMapState?.mapData?.url,
                },
              }}
              primaryButton={propStyle?.buttonPrimary}
              secondaryButton={propStyle?.buttonSecondary}
              handler={middleBodyMapState?.mapData?.url}
            />
          ))}
        </div>
      </div>
      <div className="right_section">
        <RenderMap {...mapLatLong} />
      </div>
    </ModernMiddleBodyLayout2Wrapper>
  );
};
